import React from "react";

export default ({ data, customStyle }) => {
  let listItems = data.map((item, key) => <li key={key}>{item}</li>);
  return <ul className={customStyle}>{listItems}</ul>;
};
